<template>
  <div>
    <!-- Popup -->
    <vs-popup :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-full px-8">
            <!-- Period -->
            <div class="vx-row mb-2" v-if="!data">
              <label class="vs-input--label">Period *</label>
              <select-2
                class="w-full"
                :name="'period'"
                placeholder="Select Period"
                v-validate="'required'"
                :options="PERIOD"
                autocomplete
                :ssr="true"
                :multiple="false"
                :value="form.period"
                data-vv-as="Period"
                @input="(item) => (form.period = item && item.value)"
              />

              <span class="text-danger text-sm" v-show="errors.has(`period`)">{{ errors.first(`period`) }}</span>
            </div>
            <div class="vx-row mb-2" v-else>
              <label class="vs-input--label">Period</label>
              <div class="flex items-center ml-2">{{ form.period }}</div>
            </div>

            <!-- Name -->
            <div class="vx-row mb-2">
              <vs-input placeholder="Enter title" class="w-full" v-validate="'required|exclude_special_char'" v-model="form.item.name" label="Name *" name="name" data-vv-as="Name" id="Name" />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>

            <!-- Amount -->
            <div class="vx-row mb-2">
              <vs-input placeholder="Enter amount" class="w-full" v-validate="'required|decimal'" v-model="form.item.amount" label="Amount *" name="amount" data-vv-as="Amount" id="amount" />
              <span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
            </div>

            <!-- Description -->
            <div class="vx-row mb-2">
              <label class="vs-input--label" for="description">Description *</label>
              <vs-textarea
                placeholder="Enter description"
                class="w-full mb-0"
                id="description"
                v-validate="'required|exclude_special_char'"
                name="description"
                v-model="form.item.description"
                data-vv-as="Description"
                :rows="3"
              />
              <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="create-subscription-plan" @click="save_changes">{{ action_name }}</vs-button>
              <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  /** Page Name */
  name: `subscriptionPlanAction`,

  /** components */
  components: {
    Select2
  },

  /** Props */
  props: {
    showModal: Boolean,
    data: Object,
    module_name: String,
    action_name: String
  },

  /** data */
  data() {
    return {
      form: {
        period: null,
        interval: 1,
        item: {
          name: '',
          amount: '',
          currency: 'INR',
          description: ''
        }
      },
      PERIOD: []
    }
  },

  /** created */
  async created() {
    this.PERIOD = [
      {
        value: 'monthly',
        label: 'Monthly'
      },
      {
        value: 'yearly',
        label: 'Yearly'
      }
    ]

    /** created */
    if (this.data) {
      this.form.period = this.data.period ? this.data.period : ''
      this.form.item.name = this.data.info.item.name ? this.data.info.item.name : ''
      this.form.item.amount = this.data.info.item.amount ? this.data.info.item.amount / 100 : ''
      this.form.item.description = this.data.info.item.description ? this.data.info.item.description : ''
    }
  },
  /** computed */
  computed: {
    ...mapState('subscriptionPlan', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** methods */
  methods: {
    ...mapActions('subscriptionPlan', {
      create: 'create'
    }),
    ...mapActions('common', {
      getPreDefinedValues: 'getPreDefinedValues'
    }),
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }

      try {
        const multipliedAmount = this.form.item.amount * 100
        const payload = {
          ...this.form,
          item: {
            ...this.form.item,
            amount: multipliedAmount
          }
        }

        const result = await this.create(payload)
        const message = result.message
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.isActive = false
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-subscription-plan',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-subscription-plan > .con-vs-loading')
      }
    }
  }
}
</script>
